<template>
  <section>
    <div class="mg-b-20">
      <span class="fs-16 fw-600 color-dark">Indicative Original</span>
    </div>
    <indicatiove-original-info   :form-data="form"></indicatiove-original-info>
    <div class="pd-b-20 mg-b-20 bolder-bottom flex-sb-center">
      <span class="fs-16 fw-600 color-dark">Indicative Original</span>
      <span>
        <v-button
          gray
          @click="handleEdit">Edit Request</v-button>
      </span>
    </div>
    <kyc-info
      :form-data="form"
      :class-id="classId"
      show-document></kyc-info>
  </section>
</template>

<script>
import IndicatioveOriginalInfo from '@/views/sme/components/indicatioveOriginalInfo'
import kycInfo from '@/views/sme/components/kycInfo'
export default {
  name: 'request-detail',
  components: {IndicatioveOriginalInfo,kycInfo},
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    isAttachCustomer: {
      type: Boolean,
      default: false
    },
  },
  computed:{
    classId(){
      let {class_id} = this.form||{}
      return class_id
    }
  },
  methods:{
    handleEdit(){
      this.scrollTo(0)
      this.$emit('edit')
    }
  }
}
</script>

<style scoped>
  .bolder-bottom{
    border-bottom: 1px solid #D1D5DA;
  }
</style>
